module.exports = __webpack_public_path__ + "cloud-strategy.Br6S09rj.svg";